import styled from "styled-components";

export const StyledAlertPixContainer = styled.div`
    display: flex;
    align-items:center;
    justify-content: center;
    flex-direction: column;
    margin: 0rem 0px 2rem 0;
`
export const StyledAlertPaymentPix = styled.div`
    width: 100%;
    max-width: 280px;
    height: 100%;
    max-height:auto;
    padding: 1.5rem;
    background: #f27676;
    color: #fff;
    font-size: 1rem;
    line-height:1.4;
    border-radius: 4px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
`;

export const StyledAlertPaymentPixContent = styled.div`  `;

export const StyledAlertPaymenButton = styled.button`
    width: 100%;
    border:0;
    background: #f27676;
    max-width: 280px;
    color:#fff;
    border-radius: 4px;
    margin-top: 1rem;
    height: 40px;
    cursor: pointer;
    pointer-events: auto;
    background:#2649AF 0% 0% no-repeat padding-box;

    a{
        color:#fff;
    }
`;



